module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "premade-card start-xs",
    on: {
      "click": function($event) {
        return _vm.goToSpecificPremade(_vm.premade)
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('section', {
    staticClass: "thumbnail-container"
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.get_thumbnail_on_amazon_aws
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "card-title"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm.premade.title, 61)))])])]), _vm._v(" "), _c('section', {
    staticClass: "card-footer flex middle-xs"
  }, [_c('div', {
    staticClass: "author-info flex middle-xs pl-caption"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "9px"
    },
    attrs: {
      "src": _vm.premade.author_avatar || 'static/logos/ring.svg'
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.premade.author_name || 'Parlay'))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3bbd0dab!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/universe/premadeCard.vue
// module id = 1358
// module chunks = 61